import { useEffect, useState } from "react";
import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatRupiah, koperasiInfo } from "@/lib/dummyData";
import { ProductAPI } from "@/lib/api";

// Katalog produk siap cetak (/katalog) — buka lalu "Cetak → Simpan sebagai PDF" untuk
// dokumen katalog yang diminta payment gateway. Isinya selalu sama dengan produk di toko.
export default function Catalog() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ProductAPI.list()
      .then((rows) => setProducts(rows || []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const byCategory = products.reduce((acc, p) => {
    (acc[p.category] = acc[p.category] || []).push(p);
    return acc;
  }, {});
  const today = new Date().toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });

  return (
    <div className="mx-auto max-w-5xl px-5 lg:px-10 py-10 print:py-0 print:px-0">
      <header className="flex flex-wrap items-end justify-between gap-4 border-b border-stone-soft pb-5">
        <div>
          <h1 className="font-display text-3xl font-bold text-ink">Katalog Produk</h1>
          <div className="text-sm text-ink/75 mt-1">{koperasiInfo.name} · {koperasiInfo.website}</div>
          <div className="text-xs text-ink/55 mt-1">Per {today} · {products.length} produk · harga dalam Rupiah, sudah termasuk fee layanan, belum termasuk ongkos kirim</div>
        </div>
        <Button onClick={() => window.print()} className="rounded-full bg-forest text-white print:hidden" data-testid="catalog-print">
          <Printer size={16} /> Cetak / Simpan PDF
        </Button>
      </header>

      {loading ? (
        <p className="py-16 text-center text-sm text-ink/55">Memuat katalog…</p>
      ) : products.length === 0 ? (
        <p className="py-16 text-center text-sm text-ink/55">Belum ada produk di katalog.</p>
      ) : (
        Object.entries(byCategory).map(([cat, rows]) => (
          <section key={cat} className="mt-8 break-inside-avoid-page">
            <h2 className="font-display font-semibold text-lg text-ink mb-3">{cat}</h2>
            <div className="divide-y divide-stone-soft border border-stone-soft rounded-2xl bg-white overflow-hidden">
              {rows.map((p) => (
                <div key={p.id} className="flex gap-4 p-4 break-inside-avoid">
                  <div className="w-20 h-20 rounded-xl overflow-hidden bg-cream shrink-0">
                    {p.image && <img src={p.image} alt={p.name} className="w-full h-full object-cover" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-ink">{p.name}</div>
                    <div className="text-[11px] text-ink/55">SKU {p.sku} · Stok {p.stock}</div>
                    {p.description && <p className="text-xs text-ink/75 mt-1 line-clamp-3">{p.description}</p>}
                  </div>
                  <div className="text-right shrink-0">
                    <div className="font-display font-bold text-ink">{formatRupiah(p.price_non_member)}</div>
                    <div className="text-[11px] text-amber-700">Anggota {formatRupiah(p.price_member)}</div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))
      )}
    </div>
  );
}
